import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Router from './screens/routes'
import Toast from './components/Toast';
import { useRef, useEffect } from 'react';
import { setNavigate } from './api';

function App() {
  document.title = 'MTrack MFG Match'
  const toastRef = useRef();
  const navigate = useNavigate();

  // Set navigate immediately, not in useEffect
  setNavigate(navigate);

  // Global window nesnesine toast fonksiyonunu ekle
  window.showToast = (message, severity) => {
    toastRef.current?.showMessage(message, severity);
  };
  
  return (
    <HelmetProvider>
      <Router />
      <Toast ref={toastRef} />
    </HelmetProvider>
  );
}

// BrowserRouter'ı dışarıda tutuyoruz çünkü useNavigate hook'u BrowserRouter içinde olmalı
const AppWrapper = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default AppWrapper;
